angular.module 'zc.projects'

.directive 'zcProjectList', ->
    restrict: 'EA'
    scope:
      projects: '='
    templateUrl: '/templates/projects/views/directives/project_list.html'



// WEBPACK FOOTER //
// ../enterprise/src/zenclerk_modules/projects/directives/projects/project_list.directive.coffee